import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./style.module.scss";
import Trigger from "rc-trigger";
import { ChevronDownIcon, SmallCloseIcon } from "@chakra-ui/icons";

interface IFormSelect {
  triggerStyle?: React.CSSProperties;
  selectedVal: string;
  onChange: (value: string) => void;
  optionList: { key: string; value: string }[];
}

const FormSelect: React.FC<IFormSelect> = ({
  triggerStyle,
  selectedVal,
  onChange,
  optionList = [],
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [mountTarget, setMountTarget] = useState<null | HTMLElement>(null);
  const triggerDom = useRef(null);
  //   const [curSelected, setCurSelected] = useState<null | number>(null);
  const handleVisibleChange = (visible: boolean) => {
    setVisible(visible);
  };
  const handleTriggerClicked = () => {
    setVisible(true);
  };

  useEffect(() => {
    if (triggerDom.current) setMountTarget(triggerDom.current);
  }, []);

  //   const contentW = useMemo(() => {
  //     if (!mountTarget) return "300px";
  //     return `${mountTarget.clientWidth}px`;
  //   }, [mountTarget]);

  const content = useMemo(() => {
    return (
      <div className={styles["form-select-pop-content"]} style={{ width: "300px" }}>
        {optionList.map((item, idx) => (
          <div
            className={`${styles["form-select-option"]} ${
              item.key === selectedVal ? styles["form-select-option-selected"] : ""
            }`}
            key={idx}
            onClick={() => {
              onChange(item.key);
              setVisible(false);
            }}
          >
            {item.value}
          </div>
        ))}
      </div>
    );
  }, [optionList]);

  const clear = (e: any) => {
    e.stopPropagation();
    onChange("");
  };
  return (
    <Trigger
      getPopupContainer={() => {
        console.log([mountTarget]);
        return mountTarget ? mountTarget : document.body;
      }}
      popupVisible={visible}
      action={["click"]}
      popup={content}
      onPopupVisibleChange={handleVisibleChange}
      popupAlign={{
        points: ["tl", "bl"],
        offset: [2, 13],
      }}
    >
      <div
        ref={triggerDom}
        className={styles["form-select-trigger-wrapper"]}
        onClick={handleTriggerClicked}
        style={{ ...triggerStyle }}
      >
        {selectedVal === "" ? (
          <div className={styles["placeholder"]}>请选择企业的人员规模</div>
        ) : (
          <div className={styles["selected"]}>{optionList[Number(selectedVal) - 1]?.value}</div>
        )}

        {selectedVal === "" ? (
          <ChevronDownIcon color={"#CCC"} />
        ) : (
          <SmallCloseIcon color={"#CCC"} onClick={(e) => clear(e)} />
        )}
      </div>
    </Trigger>
  );
};

export default FormSelect;
